import base64 from 'base-64';
import { localStorage } from 'shared/utils';
import { LocalStorageKey } from 'shared/types';

import { localStorageKeys } from './containers/CustomerLogin/utils/submit';
import { deleteCookie } from './utils/cookies';

// this function checks if the user has an authorization to visit a private route and if not will send the user to the login site
interface AuthTokenPayload {
  exp: number;
  role: number;
}

export function requireAuth(): boolean {
  process.env.NODE_ENV !== 'production' &&
    window.console.log('Checking login status...', isLoggedIn());
  return !isLoggedIn() ? setLoggedOut() : true;
}

export function requireAdminAuth(): boolean {
  const loggedIn = isLoggedIn(1);
  process.env.NODE_ENV !== 'production' &&
    window.console.log('Checking admin status...', loggedIn);
  return !loggedIn ? setLoggedOut() : true;
}

export function requireSalesAuth(): boolean {
  const loggedIn = isLoggedIn(2);
  process.env.NODE_ENV !== 'production' &&
    window.console.log('Checking admin status...', loggedIn);
  return !loggedIn ? setLoggedOut() : true;
}

export function isLoggedIn(role = 4): boolean {
  if (localStorage.getItem(LocalStorageKey.TOKEN) != null) {
    const token = localStorage.getItem(LocalStorageKey.TOKEN)!;
    const { exp }: AuthTokenPayload = JSON.parse(
      base64.decode(token.split('.')[1]),
    );
    const { role: userRole }: AuthTokenPayload = JSON.parse(
      base64.decode(token.split('.')[1]),
    );
    const currentTime = new Date().getTime() / 1000;

    if (exp - currentTime <= 0) {
      return false;
    }

    if (role < userRole) {
      return false;
    }
    return true;
  }
  return false;
}

export function setLoggedOut(): false {
  localStorage.removeItem(LocalStorageKey.TOKEN);
  return false;
}

/**
 * When logging out remove cookies, localStorage and redirect to the login page.
 * @param {Function} cb - callback for custom action
 */
export function logout(cb: () => void): void {
  localStorageKeys.forEach((el) => localStorage.removeItem(el));
  deleteCookie('upcuid');
  cb();
}
